import React, { useState } from "react";

function App() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [contacts, setContacts] = useState([]);

  const addContact = () => {
    if (name === "" || phone === "") {
      alert("Please fill all fields");
      return;
    }

    const newContact = { name, phone };
    setContacts([...contacts, newContact]);

    setName("");
    setPhone("");
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>📒 Mini Address Book</h2>

      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <br /><br />

      <input
        type="text"
        placeholder="Phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />

      <br /><br />

      <button onClick={addContact}>Add Contact</button>

      <h3>Contact List:</h3>

      <ul>
        {contacts.map((c, index) => (
          <li key={index}>
            {c.name} - {c.phone}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default App;